import React, {FC, useContext} from 'react'
import {Fund} from '../types/Fund'
import SriDots from './SriDots'
import RorCell from './RorCell'
import {useTranslation} from 'react-i18next'
import {GlobalContext} from './ctx/GlobalContext'
import {format} from 'date-fns'

const ComparedFundTableRow: FC<{
    fund: Fund
    ctx: any
}> = ({fund, ctx}) => {
    const {t} = useTranslation()
    const globalCtx = useContext(GlobalContext)
    const removeCompared = (id: string) => {
        if (ctx.compared?.includes(id)) {
            ctx.setCompared((prevCompared: Array<string>) => prevCompared.filter((item) => item !== id))
            if (ctx.chartItems?.includes(id)) {
                ctx.setChartItems((prevChartItems: Array<string>) => prevChartItems.filter((item) => item !== id))
            }
        }
    }
    const fixNameFund = (fund: Fund): string => {
        if (fund.kind !== 'dfe') {
            return fund.name ? fund.name?.toString().replace(/\s(.)$/i, '\u00A0$1') : ''
        } else {
            return fund.name
        }
    }

    const noDataAvailable = (): any => {
        if (fund.valuation === undefined) return <span className="flex"></span>

        return (
            <span className="flex">
                {format(fund.valuation === null ? ctx.date : fund.valuationDate, 'dd.MM.yyyy')}
            </span>
        )
    }

    return (
        <>
            <div className="fund-table-row flex">
                <div className="fund-wrapper">
                    <div
                        className={
                            'row-wrapper std-hover ' +
                            (ctx.compared?.includes(fund.id) ? 'active' : '') +
                            (globalCtx.layout === 'dfe' ? ' row-sort-dfe row-wrapper-ofe' : '') +
                            (globalCtx.layout === 'ofe' ? ' row-wrapper-ofe' : '')
                        }>
                        <div className="row flex">
                            <div className="checkbox">
                                <label>
                                    <input
                                        type="checkbox"
                                        onChange={() => removeCompared(fund.id)}
                                        disabled={
                                            ctx.compared && !ctx.compared.includes(fund.id) && ctx.compared.length >= 10
                                        }
                                        checked={ctx.compared && ctx.compared.includes(fund.id)}
                                    />
                                </label>
                            </div>

                            <div className="row-fund flex">
                                <div className="row-name flex">
                                    <span className="name-product">{fixNameFund(fund)}</span>
                                    <span style={{display: 'inline-block'}}>
                                        {fund.isEsg ? (
                                            <>
                                                <span className="tooltip">
                                                    <img
                                                        alt="ikona"
                                                        className="icon-esg leaf"
                                                        style={{whiteSpace: 'wrap'}}
                                                    />
                                                    <span className="tooltiptext">{t('label.esg.compliant.fund')}</span>
                                                </span>
                                            </>
                                        ) : (
                                            ''
                                        )}
                                        {globalCtx.layout === 'fio' && (
                                            <span className="tooltip">
                                                <img
                                                    className={'umbrella ' + (fund.umbrellas ? fund.umbrellas[0] : '')}
                                                />
                                                <span className="tooltiptext">
                                                    {fund.umbrellas && fund.umbrellasNames
                                                        ? fund.umbrellasNames[fund.umbrellas[0]]
                                                        : ''}
                                                </span>
                                            </span>
                                        )}
                                    </span>
                                </div>
                                {globalCtx.layout === 'fio' && fund.umbrellas && fund.umbrellas[0] === 'PAR_CUN02' ? (
                                    <div className="exclusively-allianz">{t('label.fund.fio.exclusively.allianz')}</div>
                                ) : (
                                    ''
                                )}
                                {fund.url && (
                                    <a className="more" href={fund.url}>
                                        {t('label.row.btn.more')}
                                    </a>
                                )}
                            </div>
                        </div>
                        <div className="row-price flex">
                            <div className={'row-sum flex' + (globalCtx.layout === 'ufk' ? ' row-sum-ufk' : '')}>
                                {fund.valuation === null ? (
                                    <span className="no-data flex">{t('label.compare.no.data')}</span>
                                ) : (
                                    <span className="flex">
                                        {fund.valuation?.toLocaleString('pl-PL', {
                                            minimumFractionDigits: fund.fractionalDigits,
                                            maximumFractionDigits: fund.fractionalDigits,
                                        })}{' '}
                                        {fund.currency}
                                    </span>
                                )}
                                <div className="row-ju flex">{noDataAvailable()}</div>
                            </div>
                            {globalCtx.layout === 'fio' && (
                                <div className="row-sri flex">
                                    <SriDots sri={fund.sri} />
                                </div>
                            )}
                            {ctx.compareColumns.includes('1D') && <RorCell label={'1D'} val={fund.oneDay} />}
                            {ctx.compareColumns.includes('1M') && <RorCell label={'1M'} val={fund.oneMonth} />}
                            {ctx.compareColumns.includes('3M') && <RorCell label={'3M'} val={fund.threeMonths} />}
                            {ctx.compareColumns.includes('6M') && <RorCell label={'6M'} val={fund.sixMonths} />}
                            {ctx.compareColumns.includes('12M') && <RorCell label={'12M'} val={fund.oneYear} />}
                            {ctx.compareColumns.includes('36M') && <RorCell label={'36M'} val={fund.threeYears} />}
                            {ctx.compareColumns.includes('60M') && <RorCell label={'60M'} val={fund.fiveYears} />}
                            {ctx.compareColumns.includes('YTD') && <RorCell label={'YTD'} val={fund.yearToDate} />}
                            {ctx.compareColumns.includes('MAX') && <RorCell label={'MAX'} val={fund.max} />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ComparedFundTableRow
